import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SaveStateData } from 'dbweb-core';
import { ElementComponent } from './element.component';
import {
	MatFormFieldModule,
	MatInputModule,
	MatButtonModule,
	MatCheckboxModule,
	MatSelectModule,
	MatRadioModule,
	MatIconModule,
	MatTableModule,
	MatAutocompleteModule,
	MatSidenavModule,
	MatTooltipModule,
	MatSlideToggleModule,
	MatDialogModule,
	MatDividerModule
} from '@angular/material';
import { AceEditorModule } from 'ng2-ace-editor';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { FormsModule } from '@angular/forms';
import { BillModule } from '../bill/bill.module';
import { SetPropertyRecordviewComponent } from './set-property-recordview/set-property-recordview.component';
import { ParamsRecordviewFetchSQLComponent } from './set-property-recordview/params-recordview-fetch-sql/params-recordview-fetch-sql.component';
import { SetPropertyImportComponent } from './set-property-import/set-property-import.component';
import { ProcessingListsComponent } from './set-property-recordview/processing-lists/processing-lists.component';
import { ViewDefineModule } from '../components/view-define/view-define.module';
import { IconSelectModule } from '../components/icon-select/icon-select.module';
import { LabelManagerModule } from '../components/label-manager/label-manager.module';
import { ConditionalTemplateComponent } from './set-property-recordview/conditional-template/conditional-template.component';
import { SelectSettingComponent } from './set-property-recordview/conditional-template/select-setting/select-setting.component';
import { SliderSettingComponent } from './set-property-recordview/conditional-template/slider-setting/slider-setting.component';
import { RangeInputSettingComponent } from './set-property-recordview/conditional-template/range-input-setting/range-input-setting.component';
import { Ng5SliderModule } from 'ng5-slider';
import { SetPropertyBillComponent } from './set-property-bill/set-property-bill.component';
import { SetPropertyUpdateComponent } from './set-property-update/set-property-update.component';
import { SetParamsComponent } from './set-property-update/set-params/set-params.component';
import { ListParamsComponent } from './set-property-update/list-params/list-params.component';
import { ImportFieldComponent } from './set-property-import/import-field/import-field.component';
import { ImportSetComponent } from './set-property-import/import-set/import-set.component';
@NgModule({
	declarations: [
		ElementComponent,
		SetPropertyRecordviewComponent,
		ParamsRecordviewFetchSQLComponent,
		SetPropertyImportComponent,
		ConditionalTemplateComponent,
		ProcessingListsComponent,
		SelectSettingComponent,
		SliderSettingComponent,
		RangeInputSettingComponent,
		SetPropertyBillComponent,
		SetPropertyUpdateComponent,
		SetParamsComponent,
		ListParamsComponent,
		ImportFieldComponent,
		ImportSetComponent
	],
	imports: [
		BillModule,
		CommonModule,
		MatFormFieldModule,
		MatCheckboxModule,
		MatSelectModule,
		FormsModule,
		MatInputModule,
		MatButtonModule,
		MatIconModule,
		DragDropModule,
		MatTableModule,
		MatRadioModule,
		MatTooltipModule,
		MatAutocompleteModule,
		MatSlideToggleModule,
		MatDialogModule,
		AceEditorModule,
		MatSidenavModule,
		ViewDefineModule,
		IconSelectModule,
		LabelManagerModule,
		MatDividerModule,
		Ng5SliderModule,
		RouterModule.forChild([
			{
				path: '**',
				component: ElementComponent,
				data: SaveStateData
			}
		])
	],
	entryComponents: [SetParamsComponent, ListParamsComponent]
})
export class ElementModule {}
